import { FileRoutesByTo } from '../../routeTree.gen.ts';

type TRoutes = keyof FileRoutesByTo;

export const employeeUserRoutes: Record<string, TRoutes> = {
  userDashboard: '/user/dashboard',
  userProfile: '/user/profile',
  userProfileDemographics: '/user/profile/demographics',
  userProfileContact: '/user/profile/contact',
  // screener: '/screener',
  // assessment: '/assessment',
  onboardingUser: '/onboarding/user',
  onboardingWholenessScreener: '/onboarding/wholeness-screener',
  growthZone: '/user/growth-zone',
  explore: '/explore',
};

export const peerSupportRoutes: Record<string, TRoutes> = {
  ...employeeUserRoutes,
  peerSupportDashboard: '/organization/dashboard/peer-support',
};

export const contentCreatorRoutes: Record<string, TRoutes> = {
  ...employeeUserRoutes,
  creatorProfile: '/creator/profile',
  creatorContentCreate: '/creator/content/create',
};

export const orgAdminRoutes: Record<string, TRoutes> = {
  ...employeeUserRoutes,
  organizationDashboard: '/organization/dashboard',
  organizationRoster: '/organization/roster',
  onboardingOrganization: '/onboarding/organization',
  peerSupportDashboard: '/organization/dashboard/peer-support',
};

export const superAdminRoutes: Record<string, TRoutes> = {
  organizationDashboard: '/organization/dashboard',
  peerSupportDashboard: '/organization/dashboard/peer-support',
  organizationRoster: '/organization/roster',
  peerSupportDirectory: '/directory/peer-support',
  providersDirectory: '/directory/provider',
  memberCareDirectory: '/directory/member-care',
};

const appRoutes = {
  ...orgAdminRoutes,
};

export default appRoutes;
